import { EctDb } from './EctDb';

export const db = new EctDb();
